import React from 'react';
import {  MuiGrid, MuiTypography } from '../../ui/MaterialUIComponents';


class TimeSlotHeaderComponent extends React.Component {
  
  componentDidMount() {
    let anElement =  Array.from(document.querySelectorAll('h6'))
  .find(el => el.textContent.includes('7 AM'));

  if(anElement){
    anElement.scrollIntoView(true);
  }
}
  render() {
    return (
        <MuiGrid style={{ display: 'flex', Direction: 'column', border: '1px solid lightgray',height: '72px'}} justify="flex-end">
        
                <MuiGrid style={{ zIndex: 100, position: 'relative'}} >
                  <MuiTypography variant="subtitle2"> {this.props.label}</MuiTypography>
                </MuiGrid>
            
        </MuiGrid>
      )
  }
}

export default TimeSlotHeaderComponent;